// Styles
import './cards-carousel.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initCardsCarousel = (context) => {
  const cardsCarouselSection = context.closest('.shopify-section');
  if (!cardsCarouselSection) return;

  const sliderContainer = cardsCarouselSection.querySelector('.cards-carousel__container');
  if (sliderContainer) {
    new Swiper(sliderContainer, {
      loop: false,
      slidesPerView: 1.37,
      spaceBetween: 24,
      freeMode: true,
      navigation: {
        nextEl: sliderContainer.querySelector('.cards-carousel__arrow.cards-carousel__arrow--right'),
        prevEl: sliderContainer.querySelector('.cards-carousel__arrow.cards-carousel__arrow--left'),
      },
      breakpoints: {
        769: {
          slidesPerView: 3
        }
      }
    });
  }
}

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.cards-carousel__container'), (el) => {
    window.dAgency.initCardsCarousel(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.cards-carousel__container'), (el) => {
      window.dAgency.initCardsCarousel(el);
    });
  });
}
